import React from 'react';


function Header({ onLogout }) {
  return (
    <header className="app-header">
      <div className="header-content">
        <img
          src="/images/travelblog_header_image.jpg"
          alt="Travel Header"
          className="header-image"
        />
        <div className="header-text-content">
          <h1>JD & Natasha's Honeymoon Adventures</h1>

          <blockquote className="header-quote">
            “The world is a book, and those who do not travel read only one page.”
          </blockquote>
          <cite className="header-cite">— St. Augustine</cite>

          <p className="header-followup">
            Follow us on our honeymoon adventures from Australia to New Zealand to Hawaii!
          </p>
        </div>
      </div>
      <button className="logout-btn" onClick={onLogout}>
        Logout
      </button>
    </header>
  );
}

export default Header;